export default __webpack_public_path__ + "static/media/TrashCan.89a97809.svg";